import HeatMapChart from './HeatMapChart';

export default HeatMapChart;
